const OpenInNew = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="open_in_new">
      <mask
        id="mask0_1683_11538"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="14"
        height="14"
      >
        <rect id="Bounding box" width="14" height="14" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1683_11538)">
        <path
          id="open_in_new_2"
          d="M3.09554 11.9596C2.80086 11.9596 2.55143 11.8576 2.34727 11.6534C2.1431 11.4492 2.04102 11.1998 2.04102 10.9051V3.09749C2.04102 2.80281 2.1431 2.55339 2.34727 2.34922C2.55143 2.14505 2.80086 2.04297 3.09554 2.04297H6.77491V2.91797H3.09554C3.05062 2.91797 3.00949 2.93668 2.97216 2.97411C2.93473 3.01145 2.91602 3.05257 2.91602 3.09749V10.9051C2.91602 10.95 2.93473 10.9912 2.97216 11.0285C3.00949 11.0659 3.05062 11.0846 3.09554 11.0846H10.9032C10.9481 11.0846 10.9892 11.0659 11.0265 11.0285C11.064 10.9912 11.0827 10.95 11.0827 10.9051V7.22574H11.9577V10.9051C11.9577 11.1998 11.8556 11.4492 11.6514 11.6534C11.4473 11.8576 11.1978 11.9596 10.9032 11.9596H3.09554ZM5.66891 8.94643L5.05422 8.33174L10.468 2.91797H8.16602V2.04297H11.9577V5.83464H11.0827V3.53266L5.66891 8.94643Z"
          fill="#413DE4"
        />
      </g>
    </g>
  </svg>
);

export default OpenInNew;
